import type { WalletSummary } from './types';

const TRACKED_ADDRESS_KEY = 'whaletail.trackedAddress.v1';
const LAST_SUMMARY_PREFIX = 'whaletail.lastSummary.v1.';

export const DEFAULT_ADDRESS = '1Ay8vMC7R1UbyCCZRVULMV7iQpHSAbguJP';
export const DEFAULT_LABEL = 'Mr.100 (BTC)';

export interface TrackedAddress {
  address: string;
  label: string;
}

function isStorageAvailable(): boolean {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch {
    return false;
  }
}

export function getTrackedAddress(): TrackedAddress {
  if (!isStorageAvailable()) {
    return { address: DEFAULT_ADDRESS, label: DEFAULT_LABEL };
  }
  try {
    const raw = window.localStorage.getItem(TRACKED_ADDRESS_KEY);
    if (!raw) return { address: DEFAULT_ADDRESS, label: DEFAULT_LABEL };
    const parsed = JSON.parse(raw) as Partial<TrackedAddress>;
    if (typeof parsed.address !== 'string' || parsed.address.length === 0) {
      return { address: DEFAULT_ADDRESS, label: DEFAULT_LABEL };
    }
    return {
      address: parsed.address,
      label:
        typeof parsed.label === 'string' && parsed.label.length > 0
          ? parsed.label
          : DEFAULT_LABEL,
    };
  } catch {
    return { address: DEFAULT_ADDRESS, label: DEFAULT_LABEL };
  }
}

export function setTrackedAddress(tracked: TrackedAddress): void {
  if (!isStorageAvailable()) return;
  try {
    window.localStorage.setItem(TRACKED_ADDRESS_KEY, JSON.stringify(tracked));
  } catch {
    // Storage may be unavailable (private browsing quota); fail silently.
  }
}

export function getLastSuccessfulSummary(address: string): WalletSummary | null {
  if (!isStorageAvailable()) return null;
  try {
    const raw = window.localStorage.getItem(LAST_SUMMARY_PREFIX + address);
    if (!raw) return null;
    return JSON.parse(raw) as WalletSummary;
  } catch {
    return null;
  }
}

export function setLastSuccessfulSummary(address: string, summary: WalletSummary): void {
  if (!isStorageAvailable()) return;
  try {
    window.localStorage.setItem(LAST_SUMMARY_PREFIX + address, JSON.stringify(summary));
  } catch {
    // Storage may be unavailable (private browsing quota); fail silently.
  }
}
